import { millisecondsInSecond, secondsToHours } from 'date-fns';
import { get, some } from 'lodash-es';

import { PullRequest } from 'src/types/pull-requests-table';
import {
  publishScreenEvent,
  publishUiEvent,
} from 'src/utils/analytics/publish';

import { PrCycleMetrics } from './api/requests';

type FireCycleTimeAnalyticsParams = {
  action: 'hovered' | 'shown';
  metrics?: PrCycleMetrics;
  pullRequest: PullRequest;
  currentUserUuid?: string;
  stale: boolean;
};

export const fireCycleTimeAnalytics = (
  params: FireCycleTimeAnalyticsParams
) => {
  const { action, metrics, pullRequest, currentUserUuid, stale } = params;

  const isAuthor = pullRequest.author?.uuid === currentUserUuid;

  const isReviewer = some(
    pullRequest.participants,
    participant =>
      get(participant, 'user.uuid', '') === currentUserUuid &&
      participant.role === 'REVIEWER'
  );

  const now = new Date();

  const prUpdatedHoursAgo = secondsToHours(
    (now.getTime() - new Date(pullRequest.updated_on).getTime()) /
      millisecondsInSecond
  );

  const prAgeInHours = secondsToHours(
    (now.getTime() - new Date(pullRequest.created_on).getTime()) /
      millisecondsInSecond
  );

  const attributes = {
    stale,
    isReviewer,
    isAuthor,
    prUpdatedHoursAgo,
    prAgeInHours,
  };

  let attributesWithMetrics;

  if (metrics) {
    const repoLowerBoundHours = secondsToHours(metrics.low.value);
    const repoMiddleBoundHours = secondsToHours(metrics.mid.value);
    const repoUpperBoundHours = secondsToHours(metrics.high.value);
    attributesWithMetrics = {
      ...attributes,
      repoLowerBoundHours,
      repoMiddleBoundHours,
      repoUpperBoundHours,
    };
  }

  const analyticsPayload = {
    action,
    actionSubject: 'prAttention',
    actionSubjectId: 'prAttention',
    source: 'pullRequestsTable',
    attributes: metrics ? attributesWithMetrics : attributes,
  };

  if (action === 'shown') {
    publishScreenEvent('prAttention', analyticsPayload.attributes);
    return;
  }

  publishUiEvent(analyticsPayload);
};
